import React, { Fragment, useState, useEffect, useContext } from "react";
import { Row, Col, Form, Alert } from "react-bootstrap";
import { FormField, Radio } from "semantic-ui-react";
import ActiveUserPass from "../../components/passes/ActiveUserPass";
import PassCard from "../../components/passes/PassCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faExclamationCircle, faExclamationTriangle, faInfoCircle, faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import "./../../pages/schedule/schedules.css";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import PaymentTypesButtons from "../buttons/PaymentTypesButtons";

const ChoosePass = (props) => {
    const { t } = useTranslation();
    const {
        selectedPass,
        setSelectedPass,
        setFormChanged,
        blockForm,
        classID,
        userID,
        modalView,
        addingToClassByInstr,
        selectedPassWithoutSigningIn,
        setSelectedPassWithoutSigningIn,
        onShowPaymentForPassModal,
        reloadActivePasses,
        setReloadActivePasses,
    } = props;
    const { checkServerData } = useContext(BasicContext);
    const [userPasses, setUserPasses] = useState(null);
    const [passesList, setPassesList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tooMuchNotPaidPasses, setTooMuchNotPaidPasses] = useState(null);
    const [oneNotPaidPass, setOneNotPaidPass] = useState(null);
    const [purchasePassPriv, setPurchasePassPriv] = useState(null);

    useEffect(() => {
        if (reloadActivePasses) {
            setLoading(true);
            setTimeout(() => {
                getActivePasses();
            }, 200);
        }

        return () => setReloadActivePasses(false);
        // eslint-disable-next-line
    }, [reloadActivePasses]);

    const getPassWithoutSigningIn = async () => {
        const res = await postMethod("/get-pass-without-signing-in");
        if (checkServerData(res)) {
            setSelectedPassWithoutSigningIn({ pass: res.data.pass, paymentMethod: null });
        }
        setLoading(false);
    };

    const getPassesList = async () => {
        const res = await postMethod("/get-passes-list-for-class-purchase", { classID: classID, addingToClassByInstr: addingToClassByInstr });
        if (checkServerData(res)) {
            setPassesList(res.data.list);
        }
        setLoading(false);
    };

    const getActivePasses = async () => {
        const res = await postMethod("/get-active-passes", { classID: classID, userID: userID });
        if (checkServerData(res)) {
            setPurchasePassPriv(res.data.purchasePassPriv);

            if (res.data.code === "tooMuchNotPaidActivePasses") {
                //za dużo nieopłaconych karnetów
                setTooMuchNotPaidPasses({
                    variant: "danger",
                    message: (
                        <>
                            <FontAwesomeIcon icon={faExclamationCircle} className="me-2" />
                            {t(`error.tooMuchNotPaidActivePasses${addingToClassByInstr ? "ByStudent" : ""}`)}
                        </>
                    ),
                });
                //jeśli instruktor dodaje - wyświetl specjalny karnet, jeśli kursant - nic nie wyświetlaj
                if (addingToClassByInstr) getPassWithoutSigningIn();
                else setLoading(false);
            } else {
                //jeśli tylko 1 lub 0 nieopłaconych karnetów

                //jeśli tylko 1 nieopłacony karnet
                if (res.data.atLeastOneNotPaidPass) {
                    setOneNotPaidPass({
                        variant: "warning",
                        message: (
                            <>
                                <FontAwesomeIcon icon={faWarning} className="me-2" />
                                {t(`warning.oneNotPaidPass${addingToClassByInstr ? "ByStudent" : ""}`)}
                            </>
                        ),
                    });
                }
                //tryb instruktora
                if (addingToClassByInstr) {
                    if (res.data.list.length > 0) {
                        //jeśli są aktywne karnety - wyświetl
                        setUserPasses(res.data.list);
                        setTimeout(() => {
                            setLoading(false);
                        }, 200);
                    } else {
                        //jeśli brak aktywnych karnetów - wyświetl specjalny karnet do zakupu
                        getPassWithoutSigningIn();
                    }
                } else {
                    //tryb kursanta

                    //jeśli są aktywne karnety - wyświetl
                    if (res.data.list.length > 0) {
                        setUserPasses(res.data.list);
                        setTimeout(() => {
                            setLoading(false);
                        }, 200);
                    } else {
                        //jeśli brak aktywnych karnetów - wyświetl karnety do kupienia
                        getPassesList();
                    }
                }
            }
        } else setLoading(false);
    };

    useEffect(() => {
        getActivePasses();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Col xs={12} className="my-3 text-center">
                    <p className="h5">
                        {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                    </p>
                </Col>
            ) : tooMuchNotPaidPasses ? (
                <>
                    {/* za dużo nieopłaconych karnetów */}
                    <Alert variant={tooMuchNotPaidPasses.variant}>{tooMuchNotPaidPasses.message}</Alert>

                    {/* tryb instruktora - wyświetl specjalny karnet do zakupienia */}
                    {addingToClassByInstr && (
                        <Fragment>
                            {!selectedPassWithoutSigningIn ? (
                                <p className="fs-6 text-center my-2">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            ) : (
                                <Fragment>
                                    <div className="mb-3 border p-3 shadow-sm rounded bg-white">
                                        <ActiveUserPass pass={selectedPassWithoutSigningIn.pass} i={0} addingToClassByInstr />
                                    </div>
                                    <PaymentTypesButtons
                                        blockForm={blockForm}
                                        paymentMethod={selectedPassWithoutSigningIn.paymentMethod}
                                        setPaymentMethod={(v) => {
                                            setSelectedPassWithoutSigningIn({ ...selectedPassWithoutSigningIn, paymentMethod: v });
                                        }}
                                        setFormChanged={setFormChanged}
                                    />
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </>
            ) : (
                <Fragment>
                    {/* jeśli tylko 1 lub 0 nieopłaconych karnetów */}

                    {/* jeśli tylko 1 nieopłacony karnet */}
                    {oneNotPaidPass && (
                        <Col xs={12}>
                            {" "}
                            <Alert className="alert-small" variant={oneNotPaidPass.variant}>
                                {oneNotPaidPass.message}
                            </Alert>
                        </Col>
                    )}

                    {/* tryb instruktora */}
                    {addingToClassByInstr ? (
                        <Fragment>
                            {/* jeśli są aktywne karnety - wyświetl */}

                            {userPasses ? (
                                <Fragment>
                                    <Col xs={12}>
                                        <Alert variant="info">
                                            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                            {t("info.tellStudentAboutPass")}
                                        </Alert>
                                    </Col>
                                    <Col xs={12}>
                                        <p className="mt-2 fs-5">
                                            <strong>{t("passes.chooseActivePass")}</strong>
                                        </p>
                                        <Form.Group id={`activeUserPasses`}>
                                            {userPasses.map((e, i) => (
                                                <FormField key={i} className={`active-user-pass ${e.up_paid !== e.up_price && e.up_price > 0 ? "user-pass-not-paid" : ""}`}>
                                                    <Radio
                                                        disabled={blockForm}
                                                        label={
                                                            <label className={!e.up_activation_date ? "no-activation-date" : ""}>
                                                                <ActiveUserPass pass={e} i={i} />
                                                            </label>
                                                        }
                                                        name="radioGroup"
                                                        value={e.up_id}
                                                        checked={selectedPass === e.up_id}
                                                        onChange={() => {
                                                            setSelectedPass(e.up_id);
                                                            setFormChanged(true);
                                                        }}
                                                    />
                                                </FormField>
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    {/* jeśli brak aktywnych karnetów - wyświetl specjalny karnet do zakupu */}
                                    <Col xs={12}>
                                        <Alert className="alert-small" variant="info">
                                            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                            {t("info.noActivePassesSpecialPass")}
                                        </Alert>
                                    </Col>

                                    {!selectedPassWithoutSigningIn ? (
                                        <p className="fs-6 text-center my-2">
                                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                        </p>
                                    ) : (
                                        <Fragment>
                                            <div className="mb-3 border p-3 shadow-sm rounded bg-white">
                                                <ActiveUserPass pass={selectedPassWithoutSigningIn.pass} i={0} addingToClassByInstr />
                                            </div>
                                            <PaymentTypesButtons
                                                blockForm={blockForm}
                                                paymentMethod={selectedPassWithoutSigningIn.paymentMethod}
                                                setPaymentMethod={(v) => {
                                                    setSelectedPassWithoutSigningIn({ ...selectedPassWithoutSigningIn, paymentMethod: v });
                                                }}
                                                setFormChanged={setFormChanged}
                                            />
                                        </Fragment>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    ) : (
                        <Fragment>
                            {/* tryb kursanta */}

                            {/* jeśli są aktywne karnety - wyświetl */}
                            {userPasses ? (
                                <Col xs={12}>
                                    <p className="mt-2 fs-5">
                                        <strong>{t("passes.chooseActivePass")}</strong>
                                    </p>
                                    <Form.Group id={`activeUserPasses`}>
                                        {userPasses.map((e, i) => (
                                            <FormField key={i} className={`active-user-pass ${e.up_paid !== e.up_price && e.up_price > 0 ? "user-pass-not-paid" : ""}`}>
                                                <Radio
                                                    disabled={blockForm}
                                                    label={
                                                        <label className={!e.up_activation_date ? "no-activation-date" : ""}>
                                                            <ActiveUserPass pass={e} i={i} />
                                                        </label>
                                                    }
                                                    name="radioGroup"
                                                    value={e.up_id}
                                                    checked={selectedPass === e.up_id}
                                                    onChange={() => {
                                                        setSelectedPass(e.up_id);
                                                        setFormChanged(true);
                                                    }}
                                                />
                                            </FormField>
                                        ))}
                                    </Form.Group>
                                </Col>
                            ) : (
                                <Fragment>
                                    {/* brak aktywnych karnetów - wyświetl alert */}
                                    <Col xs={12}>
                                        <Alert className="alert-small" variant="info">
                                            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                                            {t("info.noActivePasses")}
                                        </Alert>
                                    </Col>
                                    {/* jeśli brak aktywnych karnetów - wyświetl karnety do kupienia */}
                                    {passesList && (
                                        <Col xs={12}>
                                            <Row>
                                                {passesList.length === 0 ? (
                                                    <Alert variant="warning">
                                                        <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                                        {t("warning.noPassesOnListToPurchase")}
                                                    </Alert>
                                                ) : (
                                                    passesList.map((e, i) => (
                                                        <Col xs={12} lg={modalView ? 12 : 6} className="" key={i}>
                                                            {purchasePassPriv !== null && (
                                                                <PassCard pass={e} i={i} allowedPermission={purchasePassPriv} onProceed={() => onShowPaymentForPassModal(e)} />
                                                            )}
                                                        </Col>
                                                    ))
                                                )}
                                            </Row>
                                        </Col>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default ChoosePass;
